/**
 * Some business domain info:
 *
 * "AVA" is a fixed German term and an abbreviation for
 * "Ausschreibung, Vergabe und Abrechnung" ("tendering, awarding and invoicing").
 *
 * "GAEB" is an abbreviation for the German "Gemeinsamer Ausschuss Elektronik
 * im Bauwesen" – "joint committee electronics in the building industry" whose
 * data formats were also adopted by other branches of the building industry,
 * e.g. HVAC (heating, ventilation, air conditioning).
 *
 * GAEB phases specify what information should be exchanged during this step
 * and have impact on format details as well as how clients consume and display
 * the GAEB data.
 */
export enum AvaGaebPhase {
  PHASE_X81 = "x81",
  PHASE_X84 = "x84",
  PHASE_X86 = "x86"
}

export const DEFAULT_AVA_GAEB_PHASE = AvaGaebPhase.PHASE_X81
